{
    "link" : {
        "imprint": "Imprint",
        "data privacy": "Data Privacy",
        "used licenses": "Used Licenses"
    }
}
